import { logger } from "logger";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

type EmittedEvent = AnalyticsEvent | ActionEvent;

// PageIdentifier -- page name
// PageIdentifier gonna be registered as enum later
type PageIdentifier = string;

type AnalyticsEvent = {
  type: "analytics";
  action: "pageview" | "click";
  source: PageIdentifier;
  message?: string;
};

type ActionEvent = {
  type: "action";
  action:
    | "close"
    | "auth-error"
    | "plaid_link_handoff"
    | "unsubscribe"
    | "pay_rent_handoff"
    | "connect_bank";
  source?: PageIdentifier;
  message?: string;
};

export const postEvent = async (event: EmittedEvent) => {
  try {
    logger.info("postEvent", event.action);
    const stringifiedEvent = JSON.stringify(event);
    window?.postMessage(stringifiedEvent, "*");
    window?.parent.postMessage(stringifiedEvent, "*");
  } catch (err) {
    logger.error("postEvent error", err);
  }
};

export const usePostPageView = (source?: string, message?: string) => {
  const location = useLocation();
  useEffect(() => {
    const event: AnalyticsEvent = {
      type: "analytics",
      action: "pageview",
      source: source || location.pathname
    };
    if (message) event.message = message;
    postEvent(event);
  }, []);
};

export const PostPageView = ({
  source,
  message
}: {
  source?: PageIdentifier;
  message?: string;
}) => {
  usePostPageView(source ?? "", message);

  return null;
};
